import cplook from 'cplook';
inlinePdf = require('../../shared/inline_pdf.coffee')
trim_hiring_process = (app)->
  if $('#single-app-content .photo-frame').length > 0
    the_frame = $('#single-app-content .photo-frame')
    if $('html').hasClass('backgroundsize')
      img_url = 'url(' + the_frame.find('img').attr('src') + ')'
      the_frame.css('background-image': img_url)
    else
      frame_w = the_frame.width()
      the_frame.find('img').css
        'max-width': frame_w
        'max-height': the_steps.height()
      the_frame.find('img').addClass('active')

$(->
  $.localScroll.hash({
    duration: 1000,
    offset: -40
  })
  $(document).on 'change', '.row-container input.selector', ->
    if $(this).is(':checked')
      $(this).closest('.row-container').addClass('selected')
      $('form.update-all').fadeIn()
    else
      $(this).closest('.row-container').removeClass('selected')
      if $('.row-container.selected').length < 1
        $('form.update-all').hide()

  $(document).on 'change', '#app_update_reject_reason', ->
    $(this).closest('form').find('input.btn').fadeIn('fast')

  $(document).on 'click', '#control-selectors a.select-all', ->
    $('input.selector').prop('checked', true).trigger('change')
    return false

  $(document).on 'click', '#control-selectors a.select-none', ->
    $('input.selector').prop('checked', false).trigger('change')
    return false;

  $(document).on 'click', '#skip_email_warning', (ev)->
    val = 0
    if $(this).is(':checked')
      val = 1
    $.post('/manage/users/settings', { 'skip_email_warning': val })

  $(document).on 'click', '.js-toggle-forms', ->
    if $(this).closest('.forms-container').find('.is-hidden').length > 0
      $(this).closest('.forms-container').children('.extra-forms').toggleClass('is-hidden is-visible')
      $(this).html("<a href='# id='js-toggle-forms'>Hide Forms</a>")
      return false
    else
      $(this).closest('.forms-container').children('.extra-forms').toggleClass('is-hidden is-visible')
      $(this).html("<a href='# id='js-toggle-forms'>Show Forms</a>")
      return false

  $(document).on 'click', '.text', ->
    $(this).closest('fieldset').children('button').removeClass('is-hidden').addClass('is-visible')
    return false

  $(document).on 'click', '#app_update_reject_reason_input', ->
    $(this).closest('fieldset').children('button').removeClass('is-hidden').addClass('is-visible')
    return false

  $(document).on 'click', '.js-toggle-files', ->
    filesCount = $(this).data('file-count')
    if $(this).closest('.files-container').find('.is-hidden').length > 0
      $(this).closest('.files-container').children('.file').toggleClass('is-hidden is-visible')
      $(this).html("<a href='# id='js-toggle-files'>Hide Files</a>")
      return false
    else
      $(this).closest('.files-container').children('.file').toggleClass('is-hidden is-visible')
      $(this).html("<a href='# id='js-toggle-files'>View Files(" + filesCount + ")</a>")
      return false

  resize_full_tooltip = ->
    css_opts = {}
    if $('#full_tooltip').height() > $(window).height()
      css_opts.top = $(window).scrollTop() + 'px'
    else
      css_opts.top = ($(window).scrollTop() + Math.round(($(window).height() - $('#full_tooltip').height()) / 2)) + 'px'
    $('#full_tooltip').css(css_opts)

  $('.dom_updatable').on('dom_updated', ->
    dom = $(this)
    if $(window).width() > cplook.mobilePivot
      dom.find('.has-tooltip').each ->
        if $(this).data('original-title')? && $(this).attr('title').length > 0 &&
           $(this).data('original-title') != $(this).attr('title')
          if $(this).hasClass('star-tooltip')
            $(this).tooltip('hide')
          else
            $(this).tooltip('destroy')
          $(this).data('original-title', $(this).attr('title'))
          $(this).attr('data-original-title', $(this).attr('title'))
        $(this).tooltip({ container: 'body', html: true })
    autosize(dom.find('.autosize'))
    dom.find('.replacement').blur()
    dom.find('a[data-method]').each ->
      $(this).data('remote', $(this).attr('data-remote'))
      $(this).data('method', $(this).attr('data-method'))

    trim_hiring_process(dom)

    $('body.manage.apps .index .resume_preview').hoverIntent(->
      that = $(this)
      return if that.data('loading')
      if $('#full_tooltip').length < 1
        $('body').append($("<div id=\"full_tooltip\"><a class=\"close\">X</a><div class=\"content\"></div></div>"))
        $('#full_tooltip a.close').bind('click', (ev)->
          ev.preventDefault()
          $('#full_tooltip').hide()
          false
        )
      if that.data('resume')
        $('#full_tooltip .content').html(that.data('resume'))
      else
        $('#full_tooltip .content').html("<div class=\"ajaxload\"></div>")
        that.data('loading', true)
        $.get(that.attr('data-resume-url'), (data)->
          $('#full_tooltip .content').html(data).show()
          that.data('resume', data)
          resize_full_tooltip()
          that.data('loading', false)
        )
      resize_full_tooltip()
      $('#full_tooltip').show()
    , ->
      $('#full_tooltip').hide()
    )
  )
  autosize($('.autosize'))

  $(document).on 'click', 'a.edit_app_links_files', (ev)->
    $('.modal.in').modal('hide')
    mtitle = $(this).attr('title')
    m = window.get_modal_markup()
    m.load($(this).attr('href'), ->
      buttons = """
                <button type="button" class="btn btn-primary save">Save</button>
                """
      m.html(window.get_modal_content(mtitle, m.html(), buttons))
      m.find('.modal-dialog').addClass('modal-lg')

      m.find('.modal-footer button.save').click ->
        m.find('form').append('<input type="hidden" name="orig_path" value="' + location.href + '"/>')
        m.find('form').submit()

      m.modal()
    )
    return false

  $(document).on 'change', '.app-external-site-link .link-type select', (ev)->
    if $(this).val() == '0'
      $(this).closest('.app-external-site-link').find('.name').show()
    else
      $(this).closest('.app-external-site-link').find('.name').hide()

  $(document).on 'change', '.app-attachments .name input', (ev)->
    $(this).closest('.app-attachments').find('span.file-name').html($(this).val())
)
$(window).on 'load', ->
  $('.app').each ->
    trim_hiring_process($(this))

$(document).on 'click', '.external_background_form input[type=submit]', ->
  app_id = $(this).closest('.row-container.app').attr('id').split('app-').pop()
  $.ajax
    url: "/manage/apps/#{app_id}/comments.js"
    method: 'POST'
    data:
      app_comment:
        comment: "Initiated background screening"

dismissInactiveWindow = ->
  $(this).closest('.row-container.app').hide()
  $(this).closest('.app_inactive.dismissable').hide()

$(document).on 'click', '.app_inactive.dismissable .dismiss-x', dismissInactiveWindow
$(document).on 'click', '.app_inactive.dismissable .undo', dismissInactiveWindow

$(document).on 'click', '.app-reject .action.reject.has-tooltip', ->
  $('.tooltip.fade.top.in').hide()

$(document).on 'shown.bs.collapse', '#app_filters_wrapper', ->
  $('#app_filters_toggle .fa').removeClass('fa-angle-down')
  $('#app_filters_toggle .fa').addClass('fa-angle-up')
$(document).on 'hidden.bs.collapse', '#app_filters_wrapper', ->
  $('#app_filters_toggle .fa').removeClass('fa-angle-up')
  $('#app_filters_toggle .fa').addClass('fa-angle-down')

$(document).on 'mouseleave', '.star-tooltip', ->
  $(this).blur()

$(document).on 'ready', 'star-tooltip', ->
  $(this).tooltip({ trigger: "focus" })

